export default __webpack_public_path__ + "static/media/KOD0128-min.49d915a0.webp";